import { Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import useEditorParams from '../../../newEditor/hook/params';
import useEditor from '../../../newEditor/hook/editor';
import EditorContainer from '../../../newEditor/editorContainer';
import { CatCommandPanel } from '../../../newEditor/commandPanels';
import { DocumentBody, Footer } from '../../../../components/Containers/docs';
import HidableContainer from '../../../documents/common/hidableContainer';
import { EditorControls, editorHooks } from '../../../basicEditor/editorControls';
import meta from '../../../../meta';
import { CiatAppContext } from '../../../../providers';

const { backendURL } = meta.cat.personcontragent;

function Editor({
  onSave, onClose, id,
}) {
  const editorParams = useEditorParams();
  const {
    data, actions, fields, fieldErrors, nonFieldErrors, options, isNew, changed, permissions,
    loading, systemErrors, headerReadOnlyFields, printForms, headerProps,
  } = useEditor({
    backendURL,
    id,
    onCloseCallBack: onClose,
    onSaveCallBack: onSave,
    ...editorParams,
  });

  const contragentProps = editorHooks.useItemInputProps('contragent', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const inspectionProps = editorHooks.useItemInputProps('inspection', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const firstNameProps = editorHooks.useStringInputProps('first_name', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const lastLameProps = editorHooks.useStringInputProps('last_name', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const surnameProps = editorHooks.useStringInputProps('surname', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const additionalPhoneNumberProps = editorHooks.useStringInputProps('additional_phone_number', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const emailProps = editorHooks.useStringInputProps('email', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const phoneNumberProps = editorHooks.useStringInputProps('phone_number', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const rankProps = editorHooks.useStringInputProps('rank', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const deletedProps = editorHooks.useCheckboxInputProps('deleted', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const { currentUser } = useContext(CiatAppContext);
  const isSuperuser = currentUser.is_superuser;

  return (
    <EditorContainer
      isNew={isNew}
      name={options.name}
      repr={data.repr}
      isLoading={loading}
      err={systemErrors}
      nonFieldErrors={nonFieldErrors}
      onClearNonFieldErrors={actions.onClearNonFieldErrors}
      onClearErrors={actions.onClearErrs}
      onClose={actions.onClose}
      changed={changed}
      fields={fields}
      CommandPanel={(
        <CatCommandPanel
          backendURL={backendURL}
          permissions={permissions}
          actions={actions}
          changed={changed}
          executed={data.executed}
          printForms={printForms}
          id={id}
          repr={data.repr}
        />
      )}
    >
      <DocumentBody>
        <HidableContainer>
          <Container fluid style={{ padding: '0' }}>
            <Row>
              <Col>
                <EditorControls.StringInput {...firstNameProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...lastLameProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...surnameProps} />
              </Col>
              <Col>
                <EditorControls.ItemPicker {...contragentProps} />
              </Col>
            </Row>
            <Row>
              {isSuperuser && (
              <Col>
                <EditorControls.ItemPicker {...inspectionProps} backend="/api/references/refinspection/" />
              </Col>
              )}
              <Col>
                <EditorControls.StringInput {...phoneNumberProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...additionalPhoneNumberProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...emailProps} />
              </Col>
            </Row>
            <Row>
              <Col className="mt-2" sm={3}>
                <EditorControls.CheckboxInput {...deletedProps} />
              </Col>
              <Col sm={9}>
                <EditorControls.StringInput {...rankProps} />
              </Col>
            </Row>
          </Container>
        </HidableContainer>
      </DocumentBody>
      <Footer
        created={data.created_at}
        updated={data.updated_at}
        readOnly={!permissions.canChange}
        inspection={data.inspection}
        onChange={actions.onChange}
        id={id}
        headerProps={headerProps}
      />
    </EditorContainer>
  );
}

Editor.propTypes = {
  id: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

Editor.defaultProps = {
  onClose: null,
  onSave: null,
};

export default Editor;
